import React from 'react'
import useSettings from 'app/hooks/useSettings'

const MatxLogo = ({ className, size = 48 }) => {
    const { settings } = useSettings()
    const theme = settings.themes[settings.activeTheme]

    return (
        <svg  className={className}
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 1080.000000 1080.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
               fill={theme.palette.primary.main} stroke="none">
                <path d="M2700 8095 l-2695 -2695 2698 -2698 2697 -2697 2697 2697 2698 2698
-2695 2695 c-1482 1482 -2697 2695 -2700 2695 -3 0 -1218 -1213 -2700 -2695z
m3015 -1125 c145 -31 264 -72 400 -140 441 -220 750 -624 856 -1120 20 -90 23
-135 23 -310 0 -175 -3 -220 -23 -310 -32 -151 -73 -268 -141 -405 -220 -441
-624 -750 -1120 -856 -90 -20 -135 -23 -310 -23 -175 0 -220 3 -310 23 -151
32 -268 73 -405 141 -441 220 -750 624 -856 1120 -20 90 -23 135 -23 310 0
175 3 220 23 310 117 546 481 981 988 1180 109 43 264 84 378 99 116 16 404 5
520 -19z"/>
            </g>
        </svg>
    )
}

export default MatxLogo
